import { render, staticRenderFns } from "./WritingBlankType1Form.vue?vue&type=template&id=5a2031de&"
import script from "./WritingBlankType1Form.vue?vue&type=script&lang=js&"
export * from "./WritingBlankType1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports